export const sizes = {
    small: 'px-2.5 py-2',
    medium: 'py-[15px] px-[20px] ',
};
